export const normalizeZipCode = (value) => ((value === undefined || value == null || value.length <= 0) ? '' : value.replaceAll('-', ''))

export const normalizePhoneNumber = (value) => ((value === undefined || value == null || value.length <= 0) ? '' : value.replaceAll(/\(?\)?\s?-?/g, ''))

export const normalizeDate = (value) => ((value === undefined || value == null || value.length <= 0) ? '' : value.replaceAll('/', ''))

export const normalizeNumber = (value) => ((value === undefined || value == null || value.length <= 0) ? '' : value.replaceAll(/\D/g, ''))
